import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import image3 from "../Images/CD-4383.jpg";
const About = () => {
  return (
    <>
      <Container className="d-flex justify-content-center align-items-center">
        <Row className="align-items-center vh-10">
          <Col md={5}>
            <img src={image3} alt="Placeholder" className="img-fluid" />
          </Col>
          <Col md={7}>
            <p>
            As a cinematographer, I live for the moments when story, emotions and light come together. Whether it's a gritty handheld sequence or 
            a meticulously lit wide shot, I approach every scene with intention and instinct. My background blends both technical precision and creative intuition. 
            I thrive on collaboration, love a good challenge, and always chase the kind of imagery that lingers long after the credits roll.  <br />
            <br/><br/>I wear a lot of hats, and I wear them well. 
            I also work as a freelance Motorsport New Zealand accredited content creator where the stories unfold at 200 km/hr.
            I shoot anything from the roar of engines on race day to the quiet tension in the pits. It’s through portrait work that I’ve developed a strong, versatile creative skill set. <br/>
            Call me a Swiss Army knife of storytelling — adaptable, curious, and always hands-on. <br/><br/>
            When I am not on camera duty, you will find me walking, hiking, camping or driving around Aotearoa with my wife Juby. 
            Together, we are working on a craft project using sand from all the beaches in Aotearoa. <br/><br/>
            <strong>AWARDS AND RECOGNITIONS</strong><br/><br/>
            48hours annual short film competition 2024, New Zealand<br/>
            Finalist in the Cinematography category <br/><br/>
            Motorsport New Zealand Media Awards <br/> Photo of the Year (2023) <br/>
            Finalist in the Photo of the Year category (2022 and 2024) <br/><br/>
            Motorsport New Zealand Media Awards  <br/>
            Finalist in Photographer of the Year (2022, 2023 and 2024) <br/>

            </p>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default About;
